import { Flex, styled } from '@grupoboticario/flora-react';
import { Button } from 'ui/components/templates/ResaleIntention/ResaleIntention/ResaleIntention.styles';
import { theme } from 'ui/theme';

export const UnavailiableItemsStyles = {
  WarmContainer: styled(Flex, {
    width: '100%',
    background: `${theme.colors.build.mediumLight2}`,
    padding: `${theme.sizes['2']} ${theme.sizes['4']}`,
  }),
  KnowMoreButton: styled(Button, {
    '&[data-unavaliable]': {
      width: '96px',
      height: '32px',
      padding: `${theme.sizes['2']} ${theme.sizes['3']}`,
      fontFamily: `${theme.fonts.primary}`,
    },
  }),
};
